<template>
	<edit></edit>
</template>

<script>
	import edit from './activity_tp_edit.vue'
	
	export default {
		name: 'activity_tp_add',
		
		components: {
			edit
		}
	}
</script>